import NoContentBlock, { NoContentBlockProps } from './NoContentBlock';

export type { NoContentBlockProps };
export default NoContentBlock;
